/* eslint-disable max-len */
import React from "react";
import { Button, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { initialStepData, StepProps } from "..";
import { useStepData } from "../context";
import StepLayout from "./layout";

const StepSuccess: React.FC<StepProps> = () => {
  const navigate = useNavigate();
  // parseUrlParams to get the listId and records
  const params = new URLSearchParams(window.location.search);
  const listName = params.get("list");
  const records = params.get("records");
  const queued = params.get("queued") === "1";
  const { viewer, setStepName, setStepData } = useStepData();

  if (!viewer) return null;
  if (!viewer!.lists) return null;

  React.useEffect(() => {
    setStepData(initialStepData);
    setStepName("Confirmation");
  }, []);

  return <StepLayout title="Import Success!" description={<Typography variant="body1">
    {queued ? (
      <>
        Your import of {records} applications to {listName} will begin momentarily in the background.
        <br/>
        We will email you when the import is complete and you can see the applications on the waitlist.
        <br/>
        You can navigate away from this page while the import is processing.
      </>
    ) : (
      <>
        You&apos;ve added {records} applications to the {listName}.<br/>
        We will email you when the import is complete and you can see the applications on the waitlist.
        <br/>
        You can navigate away from this page while the import is processing.
      </>
    )}
  </Typography>}>
    <Grid size={{ xs: 12 }}>
      <Button
        color="primary"
        variant="contained"
        onClick={() => navigate("/dash/manager/lists")}
      >
          Go to Dashboard
      </Button>
    </Grid>
  </StepLayout>;
};

export default StepSuccess;
